import { createContext, useContext } from "react";

const EpisodesContext = createContext({ mobile: false });

export default EpisodesContext;
export const useEpisodes = () => useContext(EpisodesContext);
